"use strict";
/*
 * (C) Copyright 2014 Kurento (http://kurento.org/)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Participant = void 0;
const logger_1 = require("./util/logger");
/**
 * Creates a video element for a new participant
 *
 * @param {String} name - the name of the new participant, to be used as tag
 *                        name of the video element.
 *                        The tag of the new element will be 'video<name>'
 * @return
 */
class Participant {
    constructor(name, room, ws, messageHandler) {
        this.name = name;
        this.room = room;
        this.ws = ws;
        this.messageHandler = messageHandler;
        this.sendingIceCandidates = false;
        this.messageHandler({ id: 'create', name: name });
    }
    offerToReceiveVideo(error, offerSdp) {
        if (error)
            return logger_1.logger.error(`[ARaaS] SDP Offer error: ${error}`);
        console.debug('[ARaaS] Sending SDP offer to peer');
        const msg = {
            id: 'receiveVideoFrom',
            sender: this.name,
            sdpOffer: offerSdp,
        };
        this.sendMessage(msg);
    }
    onIceCandidate(candidate) {
        if (!this.sendingIceCandidates) {
            this.sendingIceCandidates = true;
            logger_1.logger.info('[ARaaS] Started sending ICE candidates to peer');
        }
        // logger.debug('Local candidate' + JSON.stringify(candidate));
        const message = {
            id: 'onIceCandidate',
            candidate: candidate,
            name: this.name,
        };
        this.sendMessage(message);
    }
    onFirstFrameAvailable(event) {
        this.firstFrameLatencyInMs = Date.now() - this.firstFrameLatencyInMs;
        const message = {
            id: 'firstFrameLatency',
            room: this.room,
            participant: this.name,
            firstFrameLatency: this.firstFrameLatencyInMs,
        };
        this.sendMessage(message);
        this.messageHandler({
            id: 'firstFrameAvailable',
            name: this.name,
            latencyTime: this.firstFrameLatencyInMs,
        });
    }
    sendMessage(message) {
        const jsonMessage = JSON.stringify(message);
        // logger.debug('[ARaaS] Sending Participant message: ' + jsonMessage);
        this.ws.send(jsonMessage);
    }
    dispose() {
        var _a;
        (_a = this.rtcPeer) === null || _a === void 0 ? void 0 : _a.dispose();
        this.rtcPeer = undefined;
        this.videoElement = undefined;
    }
}
exports.Participant = Participant;
//# sourceMappingURL=participant.js.map